import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserLabelEntry } from '@shared/types/userLabel';
import { config } from '@shared/config';

const STORAGE_KEY = 'bv-user-label';
const DEFAULT_TTL_HOURS = 24;

function getTtlMs(): number {
  const hours = config.userLabelTtlHours ? Number(config.userLabelTtlHours) : DEFAULT_TTL_HOURS;
  return hours * 3600000;
}

interface UserLabelStore {
  entry: UserLabelEntry | null;
  setLabel: (label: string) => void;
  clearLabel: () => void;
  isExpired: () => boolean;
}

export const useUserLabelStore = create<UserLabelStore>()(
  persist(
    (set, get) => ({
      entry: null,
      setLabel: (label: string) => set({ entry: { label, timestamp: new Date().toISOString() } }),
      clearLabel: () => set({ entry: null }),
      isExpired: () => {
        const entry = get().entry;
        if (!entry) return true;
        return Date.now() - new Date(entry.timestamp).getTime() > getTtlMs();
      },
    }),
    { name: STORAGE_KEY },
  ),
);
